export default {
  videoSessionSupport: `https://support.adracare.com/hc/en-us/articles/360044075051-How-to-Change-Microphone-Camera-Settings-on-Devices`,
};
